import { AppRowContainer } from "@richbeauty";
import AppDebouncedInputSearch from "@richbeauty/core/AppDebouncedInputSearch";
import { Col, Empty, Form, Select, Spin } from "antd";
import useGetAllStates from "hooks/apis/state/useGetAllStates";
import { useIntl } from "react-intl";
import { CUSTOMER_LEAD_STATUS } from "shared/constants/AppConst";

const CustomerLeadTableSearch = ({ onValuesChange }) => {
  const { messages } = useIntl();
  const { data: allState = [], isValidating } = useGetAllStates();
  return (
    <Form style={{ width: "100%" }} onValuesChange={onValuesChange}>
      <AppRowContainer>
        <Col xs={6}>
          <Form.Item name="search" noStyle>
            <AppDebouncedInputSearch
              id="customer-lead-search"
              placeholder={messages["common.searchHere"]}
            />
          </Form.Item>
        </Col>
        <Col xs={8}>
          <Form.Item name="stateId" style={{ marginBottom: 0 }}>
            <Select
              showSearch
              allowClear
              optionFilterProp="label"
              size="middle"
              placeholder={messages["app.users.state"]}
              notFoundContent={isValidating ? <Spin size="small" /> : <Empty />}
              options={allState.map(({ name, code, id }) => ({
                value: id,
                label: `${name} (${code})`,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={8}>
          <Form.Item name="statusFilter" style={{ marginBottom: 0 }}>
            <Select
              allowClear
              showSearch
              optionFilterProp="label"
              size="middle"
              placeholder={messages["app.customerLeads.status"]}
              options={CUSTOMER_LEAD_STATUS.map((status) => ({
                value: status.value,
                label: status.label,
              }))}
            />
          </Form.Item>
        </Col>
      </AppRowContainer>
    </Form>
  );
};

export default CustomerLeadTableSearch;
